module.exports = __webpack_public_path__ + "static/media/gallery-3.d7a56cb6.jpg";